var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTower(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.06313 3.58893H1.07499L0.347656 12H2.54528L2.54539 9.07509C2.54539 7.95251 3.46239 7.03563 4.58486 7.03563C5.70745 7.03563 6.62433 7.95262 6.62433 9.07509V11.9842H8.82196L8.06313 3.58893Z",
    fill: "#8D8E92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82202 3.16206L9.1382 0H7.98408V0.395257C7.98408 0.774732 7.68365 1.07504 7.30429 1.07504C6.92482 1.07504 6.62451 0.774619 6.62451 0.395257V0H5.24904V0.395257C5.24904 0.774732 4.94862 1.07504 4.56925 1.07504C4.18978 1.07504 3.88947 0.774619 3.88947 0.395257V0H2.51369V0.395257C2.51369 0.774732 2.21327 1.07504 1.83391 1.07504C1.45443 1.07504 1.15412 0.774619 1.15412 0.395257V0H0L0.316177 3.16206H8.82202Z",
    fill: "#8D8E92"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTower);
export default __webpack_public_path__ + "static/media/tower.fabca4a2b091cb46e4c59447a4b7e873.svg";
export { ForwardRef as ReactComponent };